<script setup>
import {onMounted, ref} from "vue";
import {useContactsStore} from "@/stores/contactsStore";
import {useSDSStore} from "@/stores/sdsStore";
import {useICPStore} from "@/stores/icpStore";
import {useAuthStore} from "@/stores/authStores";

const tabGroup = ref('call');
const rules = [v => v.length <= 500 || 'Max 500 characters']
const myMsg = ref("");
const contactsStore = useContactsStore();
const sdsStore = useSDSStore();
const ICP = useICPStore().ICP;

const headers = [
  {
    title: 'Operator ID',
    key: 'operatorId',
    headerProps: {style: 'font-weight: bold'},
    value: item => item.sender === useAuthStore().loggedUser ? item.receiverName : item.senderName
  },
  {
    title: 'Time',
    key: 'time',
    sortable: true,
    headerProps: {style: 'font-weight: bold'},
    value: item => new Date(item.time).toLocaleDateString() + " " + new Date(item.time).toLocaleTimeString()
  },
  {title: 'Message', key: 'message', headerProps: {style: 'font-weight: bold'}},
  {title: 'Ack', key: 'ack', headerProps: {style: 'font-weight: bold'}},
]

const headersHistoryTab = [
  {
    title: 'Operator ID',
    key: 'operatorId',
    headerProps: {style: 'font-weight: bold'},
    value: item => item.sender === useAuthStore().loggedUser ? item.receiverName : item.senderName
  },
  {
    title: 'Time',
    key: 'time',
    sortable: true,
    headerProps: {style: 'font-weight: bold'},
    value: item => new Date(item.time).toLocaleDateString() + " " + new Date(item.time).toLocaleTimeString()
  },
  {title: 'Message', key: 'message', headerProps: {style: 'font-weight: bold'}},
  {title: 'Ack', key: 'ack', headerProps: {style: 'font-weight: bold'}},
  {
    title: 'Direction',
    key: 'direction',
    headerProps: {style: 'font-weight: bold'},
    value: item => item.sender === useAuthStore().loggedUser ? "Outgoing" : "Incoming"
  },
]

onMounted(() => {
  contactsStore.selectedTrains = [];
  contactsStore.selectedHandheld = [];
  contactsStore.selectedPhoneContacts = [];
  sdsStore.selectedMessage = [];
  sdsStore.fetchInbox();
  sdsStore.fetchHistory();
});

function colorRowItem(item) {
  return {class: sdsStore.selectedMessage.some((s) => s.value === item.item) ? "selected" : "row"};
}

function sendMessage() {
  var recievers = "";
  if (contactsStore.selectedTrains.length > 0) {
    recievers += contactsStore.selectedTrains.map(t => t.value.isdn).join(";");
  }
  if (contactsStore.selectedHandheld.length > 0) {
    recievers += recievers === "" ? "" : ";";
    recievers += contactsStore.selectedHandheld.map(h => h.value.isdn).join(";");
  }
  ICP.dispatch.sms.sendDispSMS({
    "dest": recievers,
    "content": myMsg.value,
    "mikey": "",
    "algorithm": {
      "algorithm": "",
      "rand": "",
      "id": ""
    },
    "callback": () => {
    }
  })
}

function handleSelection(event, {internalItem}) {
  const isCtrl = event.ctrlKey;
  const itemSelected = sdsStore.selectedMessage.some((s) => s.value === internalItem.value);

  if (itemSelected) { // already selected
    if (isCtrl) {
      // remove only this element from selectedMessage
      sdsStore.selectedMessage = sdsStore.selectedMessage.filter(
          (s) => s.value !== internalItem.value
      );
    } else {
      // if ctrl is not pressed, clear selection
      if (sdsStore.selectedMessage.length >= 1) {
        sdsStore.selectedMessage = [];
      }
    }
  } else { // not selected
    if (isCtrl) {
      // add to selectedMessage
      sdsStore.selectedMessage.push(internalItem);
    } else {
      // clear selection and select this item
      sdsStore.selectedMessage = [internalItem];
    }
  }
}

</script>

<template>
  <v-col class="d-flex flex-column h-100 pa-0">
    <v-card class="h-100" style="height: 100px;">
      <v-tabs
          v-model="tabGroup"
          bg-color="grey"
          height="30px"
      >
        <v-tab value="incoming">Incoming SDS</v-tab>
        <v-tab value="history">Historic SDS</v-tab>
      </v-tabs>
      <v-card-text class="pa-0 h-100">
        <v-tabs-window v-model="tabGroup" style="height: 100%;">
          <v-tabs-window-item style="height: 100%;" value="incoming">
            <v-data-table
                v-model="sdsStore.selectedMessage"
                :headers="headers"
                :items="sdsStore.messages"
                :items-per-page="-1"
                :row-props="colorRowItem"
                clickable-rows
                density="compact"
                fixed-header
                hide-default-footer
                item-value="item.item"
                return-object
                select-strategy="single"
                style="height: 100%;"
                @click:row="(event, { internalItem }) => handleSelection(event, { internalItem })"
            >
            </v-data-table>
          </v-tabs-window-item>

          <v-tabs-window-item style="height: 100%;" value="history">
            <v-data-table
                :headers="headersHistoryTab"
                :items="sdsStore.history"
                :items-per-page="-1"
                :row-props="colorRowItem"
                clickable-rows
                density="compact"
                fixed-header
                hide-default-footer
                item-value="operatorId"
                style="height: 100%;"
                @click:row="(_, {internalItem, toggleSelect}) => toggleSelect(internalItem)"
            >
            </v-data-table>
          </v-tabs-window-item>

        </v-tabs-window>
      </v-card-text>
    </v-card>
    <div id="controls" class="border-t w-100 d-flex justify-end align-center pt-1 pb-1">
      <v-btn :disabled="sdsStore.selectedMessage.length === 0" class="mr-3"
             @click="sdsStore.acknowledge()">Acknowledge Selected
      </v-btn>
      <v-btn :disabled="sdsStore.messages.length === 0" class="mr-3" @click="sdsStore.acknowledgeAll()">Acknowledge
        All
      </v-btn>
    </div>
    <div v-if="sdsStore.selectedMessage.length === 0"
         class="border-t w-100 d-flex justify-end align-center bg-surface-light">
      <v-row class="  d-flex flex-row width-100" cols="24">
        <v-col class="mt-6 pt-0 pb-0 pr-1" cols="22">
          <v-textarea
              v-model="myMsg"
              :rules="rules"
              class="ml-2"
              clearable
              counter
              label="Compose Message"
              no-resize
              rows="4"
              style="overflow: auto; padding-bottom: 20px; max-height: 200px;"
              variant="solo"
          >
          </v-textarea>
        </v-col>
        <v-col class="align-content-center " cols="1">
          <v-btn
              :disabled="myMsg==='' || contactsStore.selectedTrains.length + contactsStore.selectedHandheld.length === 0"
              class="mr-4" icon="mdi-send"
              @click="sendMessage"></v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="sdsStore.selectedMessage.length > 0"
         class="border-t w-100 d-flex justify-end align-center bg-surface-light">
      <v-row class="pa-2 d-flex flex-row width-100" cols="25">
        <v-col class="mt-6 pt-0 pb-0" cols="22">
          <v-textarea

              :label="`${sdsStore.selectedMessage[0]?.value?.sender} - ${new Date(sdsStore.selectedMessage[0]?.value?.time).toLocaleDateString()}  ${new Date(sdsStore.selectedMessage[0]?.value?.time).toLocaleTimeString()}`"
              :model-value="sdsStore.selectedMessage[0]?.value?.message"
              counter
              no-resize
              readonly
              rows="4"
              style="overflow: auto; max-height: 200px;"
              variant="solo"
          >
          </v-textarea>
        </v-col>
      </v-row>
    </div>
  </v-col>

</template>

<style scoped>

#controls {
  height: 70px;
  background-color: darkgray;
}

.newMess {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.v-card {
  border-radius: 0%;
}

:deep(.row-emergency) {
  background-color: #EE5A5AFF;
  color: white;
}

:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.row-emergency:hover) {
  background-color: #933030;
  color: white;
}

:deep(.selected) {
  background-color: #3f3f3f;
  color: white;
}

</style>